"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var items_repository_1 = require("./items-repository");
var StatefulItemsRepository = /** @class */ (function () {
    function StatefulItemsRepository(name, onUpdate) {
        var _this = this;
        this.onUpdate = onUpdate;
        this.state = function (done) {
            return done ? _this.doneItems : _this.todoItems;
        };
        this.todoItems = new items_repository_1.default(name, false);
        this.doneItems = new items_repository_1.default(name, true);
    }
    return StatefulItemsRepository;
}());
exports.default = StatefulItemsRepository;



//////////////////
// WEBPACK FOOTER
// ./src/infra/stateful-items-repository.ts
// module id = 444
// module chunks = 0